import React from 'react';
import useMediaManifest from '../utils/useMediaManifest';
import { RoleCTASection, RoleFeatureGridSection, RoleStepsSection } from '../components/RoleSections';
import { IconBolt, IconMenu, IconPhone, IconQr, IconShield, IconSpark } from '../components/icons';
import './Page.css';

export default function OwnerPage() {
  const media = useMediaManifest('owner');
  const hero = media[0];

  const features = [
    { icon: <IconMenu />, title: 'Menu builder', text: 'Categories, items, photos, pricing and availability in one place.' },
    { icon: <IconBolt />, title: 'Instant updates', text: 'Update prices & specials anytime — no reprints, no delays.' },
    { icon: <IconQr />, title: 'QR menus', text: 'Generate a clean QR experience for every table and location.' },
    { icon: <IconPhone />, title: 'Mobile-first UI', text: 'A premium, fast interface that looks great on every phone.' },
    { icon: <IconSpark />, title: 'Discovery', text: 'Help new customers find you with a consistent online presence.' },
    { icon: <IconShield />, title: 'Trusted & consistent', text: 'A professional design that matches your restaurant brand.' }
  ];

  const steps = [
    { title: 'Onboard your restaurant', text: 'Add your name, address, and basic details — we help you set it up.' },
    { title: 'Build your menu once', text: 'Create categories, add items, upload images, and set availability.' },
    { title: 'Go live with QR', text: 'Place QR codes on tables. Customers scan and browse instantly.' }
  ];

  return (
    <div className="page">
      <div className="container">
        <div className="pageHero pageHeroOwner">
          {hero?.type === 'video' ? (
            <video className="pageHeroMedia" src={hero.src} autoPlay muted loop playsInline />
          ) : hero ? (
            <img className="pageHeroMedia" src={hero.src} alt={hero.alt || 'Hero'} />
          ) : null}

          <div className="pageHeroContent">
            <div className="pageTopBar">
              <button className="btn btnGhost backBtn" type="button" onClick={() => (window.location.hash = '#/home')}>
                Back
              </button>

              <div className="pageTopActions">
                <a className="btn btnGhost" href="#/customer">
                  View customer page
                </a>
              </div>
            </div>

            <div>
              <div className="pageTitle">Restaurant Owner</div>
              <div className="pageSubtitle">Put your menu online, update instantly, and give guests a premium experience.</div>
            </div>

            <div className="pageChips">
              <div className="chip">Menu management</div>
              <div className="chip">QR experience</div>
              <div className="chip">Instant updates</div>
            </div>

            <div className="pageHeroCtas">
              <a className="btn btnPrimary" href="#owner-cta">
                Request onboarding
              </a>
              <a className="btn btnGhost" href="#owner-features">
                See features
              </a>
            </div>
          </div>
        </div>
      </div>

      <RoleFeatureGridSection
        id="owner-features"
        eyebrow="Services for owners"
        title="Everything you need to run digital menus"
        lead="Designed for real restaurants: fast updates, clean design, and an easy workflow for your team."
        items={features}
      />

      <RoleStepsSection
        id="owner-how"
        eyebrow="How it works"
        title="Launch in 3 simple steps"
        lead="Start small and improve over time — you’re in control of updates." 
        steps={steps}
      />

      <RoleCTASection
        id="owner-cta"
        title="Ready to go live with Menu Bazaar?"
        lead="We’ll help you publish your menu, generate QR codes, and make your online presence look premium from day one."
        bullets={["Quick onboarding", "Updates without reprints", "Mobile-first experience"]}
        primary={{ href: '#/home#get-started', label: 'Request a demo' }}
        secondary={{ href: '#/home', label: 'Back to landing' }}
      />
    </div>
  );
}
